import React from 'react'

export const HeroIllustration: React.FC<{ className?: string }> = ({ className = '' }) => {
  return (
    <div
      className={`relative w-full overflow-hidden rounded-2xl bg-gradient-to-b from-[#E0F2FE]/70 via-[#ECFDF5]/60 to-[#F8FAFA] p-4 border border-[#E0F2FE] ${className}`}
      aria-hidden="true"
    >
      <svg
        viewBox="0 0 400 130"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="w-full h-auto max-h-[110px] mx-auto select-none"
      >
        {/* Soft morning sky background glow */}
        <circle cx="200" cy="55" r="42" fill="#FEF3C7" opacity="0.8" />
        <circle cx="200" cy="55" r="26" fill="#FBBF24" opacity="0.9" />

        {/* Distant mountains / horizon */}
        <path
          d="M0 110C60 95 130 92 190 98C250 104 330 96 400 105V130H0V110Z"
          fill="#CCFBF1"
          opacity="0.85"
        />

        {/* Mid-ground rolling hills */}
        <path
          d="M0 115C80 102 150 108 210 112C280 116 340 104 400 112V130H0V115Z"
          fill="#99F6E4"
          opacity="0.75"
        />

        {/* Winding path towards the morning sun (PetaEsok / Perjalanan hidup) */}
        <path
          d="M200 78C198 88 190 98 185 108C178 120 172 130 170 130H230C225 125 218 114 212 104C208 94 204 84 200 78Z"
          fill="#FEF3C7"
          opacity="0.9"
        />

        {/* Foreground lush green base */}
        <path
          d="M0 122C90 118 160 124 240 120C320 116 370 122 400 122V130H0V122Z"
          fill="#14B8A6"
          opacity="0.35"
        />

        {/* Left Sprout / Tunas Harapan */}
        <g transform="translate(60, 68) scale(0.65)">
          <circle cx="25" cy="10" r="6" fill="#FBBF24" />
          <path d="M24 24C24 32 23 40 25 46C24 45 23 43 23 41C22 34 23 27 24 24Z" fill="#0F766E" />
          <path d="M23 28C20 27 10 24 7 17C5 13 8 10 12 11C18 12 22 20 23 28Z" fill="#10B981" />
          <path d="M25 26C27 25 38 20 41 14C43 10 41 7 37 8C30 10 26 18 25 26Z" fill="#0F766E" />
        </g>

        {/* Right Sprout / Tunas Harapan */}
        <g transform="translate(310, 72) scale(0.55)">
          <circle cx="25" cy="10" r="6" fill="#FBBF24" />
          <path d="M24 24C24 32 23 40 25 46C24 45 23 43 23 41C22 34 23 27 24 24Z" fill="#0F766E" />
          <path d="M23 28C20 27 10 24 7 17C5 13 8 10 12 11C18 12 22 20 23 28Z" fill="#10B981" />
          <path d="M25 26C27 25 38 20 41 14C43 10 41 7 37 8C30 10 26 18 25 26Z" fill="#0F766E" />
        </g>
      </svg>
    </div>
  )
}

export default HeroIllustration
